async function clearCart() {
    const pageUrl = location.href
    const isCartPage = pageUrl.includes('cart');
    const response = await fetch('/cart/clear', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
    })
    const data = await response.json();
    document.dispatchEvent(
      new CustomEvent('cart:refresh')
    )
    if(isCartPage) {
        location.reload()
    }
}